import React from 'react';
import { makeObservable, observable, action, computed } from 'mobx';

export default class RatingCardViewModel {
  @observable id;
  @observable nickname;
  @observable avatar;
  @observable createdAt;
  @observable title
  @observable score;
  @observable comment;
  @observable reply;
  @observable repliedAt;

  ref = React.createRef();
  officialRef = React.createRef();
  @observable isOverflow = false;
  @observable overflowOpen = false;

  @observable isOfficialOverflow = false;
  @observable officialOverflowOpen = false;

  constructor(data) {
    makeObservable(this);

    this.deserialize(data);
  }

  @action
  deserialize = (data) => {
    this.id = data.id;
    this.nickname = data.user.nickname;
    this.avatar = data.user.avatar;
    this.createdAt = data.createdAt;
    this.title = data.title;
    this.score = data.score;
    this.comment = data.comment;
    this.reply = data.reply;
    this.repliedAt = data.repliedAt;
  }

  @action
  didMount = () => {
    this.checkForOverflow();
    this.checkForOfficialOverflow();
  }

  @action
  checkForOverflow = () => {
    if (this.ref.current.clientHeight < this.ref.current.scrollHeight) {
      this.isOverflow = true;
    }
  }

  @action
  checkForOfficialOverflow = () => {
    if (!this.officialRef.current) {
      return;
    }
    if (this.officialRef.current.clientHeight < this.officialRef.current.scrollHeight) {
      this.isOfficialOverflow = true;
    }
  }

  @action
  onOverflowClick = () => {
    this.overflowOpen = true;
  }

  @action
  onOfficialOverflowClick = () => {
    this.officialOverflowOpen = true;
  }
}
